var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.34156 0.5H10.6582C10.823 0.500691 10.9839 0.550237 11.1206 0.642372C11.2572 0.734508 11.3635 0.865096 11.426 1.01762C11.4884 1.17015 11.5042 1.33776 11.4714 1.49928C11.4386 1.66079 11.3586 1.80894 11.2416 1.925L6.59156 6.57499C6.51409 6.6531 6.42192 6.71509 6.32037 6.7574C6.21882 6.79971 6.1099 6.82149 5.99989 6.82149C5.88988 6.82149 5.78096 6.79971 5.67941 6.7574C5.57786 6.71509 5.48569 6.6531 5.40823 6.57499L0.758225 1.925C0.641207 1.80894 0.561231 1.66079 0.52841 1.49928C0.495589 1.33776 0.511397 1.17015 0.573835 1.01762C0.636273 0.865096 0.742537 0.734508 0.87919 0.642372C1.01584 0.550237 1.17675 0.500691 1.34156 0.5Z",
    fill: "#4E307A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectIcon);
export default __webpack_public_path__ + "static/media/select-icon.6a42b8eae02eda96c830540490309bed.svg";
export { ForwardRef as ReactComponent };